<template>
  <header class="main-header">
    <div class="logo">
      <img src="@new/logo.png" alt="">
    </div>
    <ul class="nav">
      <li class="nav-bar"
        v-for="(item, index) in navItems" :key="index"
        @mouseenter="toggleNav(index, true)"
        @mouseleave="toggleNav(index, false)"
        @click="goToPage(item, index)"
        :class="{
          'nav-bar--hover': index === hoverIndex,
          'nav-bar--active': activeIndex === index,
        }">
        <span>{{ item.name }}</span>
        <el-collapse-transition>
          <ul class="sub-nav" v-if="item.isExpanded">
            <li class="sub-nav-bar"
              v-for="(subItem, subIndex) in item.childs" :key="subIndex"
              @mouseenter="toggleSubNav(index, subIndex, true)"
              @mouseleave="toggleSubNav(index, subIndex, false)">
              <a :href="skipProduct(item, subItem, subItem.name)" class="base-flex">
                <span style="flex: 1;">{{ subItem.name }}</span>
                <img v-show="subItem.childs && subItem.childs.length > 0" src="@new/arrowRight.png" height="12px" alt="">
              </a>
              <ul class="third-nav" v-if="subItem.isExpanded">
                <li class="third-nav-bar" v-for="(child, childIndex) in subItem.childs" :key="childIndex">
                  <a :href="skipProduct(item, subItem, subItem.name, child.name)" class="base-flex">
                    <span style="flex: 1;">{{ child.name }}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </el-collapse-transition>
      </li>
    </ul>
    <div class="contact-us">
      <!-- <button>联系我们</button> -->
    </div>
  </header>
</template>

<script>
import { headerMenus } from '@/utils/data'
export default {
  data() {
    return {
      navItems: headerMenus,
      activeIndex: -1,
      hoverIndex: -1,
    };
  },
  methods: {
    toggleNav(index, expand) {
      this.hoverIndex = expand ? index : -1;
      const item = this.navItems[index];
      if (!item.childs) return;
      this.$set(item, "isExpanded", expand);
    },
    toggleSubNav(index, subIndex, expand) {
      const item = this.navItems[index];
      const subItem = item.childs[subIndex];
      if (!subItem.childs) return;
      this.$set(subItem, "isExpanded", expand);
    },
    goToPage(item, index) {
      this.activeIndex = index;
      this.skipPage(item);
    },
    skipProduct(menuItem, subItem, parName, name) {
      let finalHref = (process.env.VUE_APP_PUBLICPATH || '') + '' + menuItem.router, temParams = '';

      if(subItem.childs) {
        temParams = 'parName=' + parName;
      
        if(name) {
          temParams = temParams + '&name=' + name;
        }
      } else {
        temParams = 'name=' + parName;
      }

      if(finalHref.indexOf('?') !== -1) {
        finalHref = finalHref + '&' + temParams;
      } else {
        finalHref = finalHref + '?' + temParams;
      }
      return finalHref;
    },
  },
  created() {
    for (let i = 0; i < this.navItems.length; i++) {
      if(window.location.pathname.indexOf(this.navItems[i].router.split('?')[0]) !== -1) {
        if(this.navItems[i].router.indexOf('/aboutUs') === -1) {
          this.activeIndex = i;
        } else if(decodeURIComponent(window.location.search).indexOf(this.navItems[i].name) !== -1) {
          this.activeIndex = i;
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.logo img {
  width: 170px;
}

.main-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  box-sizing: border-box;
  padding: 0 90px 0 100px;
  background: #040b15;
  color: #ffffff;
  font-size: 20px;
  border-bottom: 3px solid #161B24;
}

.sub-nav-bar {
  a {
    .leftImg {
      height: 16px;
      margin-right: 16px;
    }

    .rightImg {
      height: 12px;
    }
  }
}

@mixin sub-nav-style {
  width: 323px;
  height: auto;
  background: #0e1c33;
  box-shadow: 0px 0px 21px 9px rgba(4, 11, 21, 0.24);
  border: 1px solid #1f2c41;
  color: #040b15;
  list-style: none;
  font-size: 18px;
  color: #ffffff;
  line-height: 50px;

  &-bar {
    line-height: 50px;
    padding: 0 43px 0 40px;
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
      color: #30c2f3;
    }

    img {
      display: none;
    }

    &:hover img {
      display: block;
    }
  }

  &-bar:first-child {
    margin-top: 14px;
  }

  &-bar:last-child {
    margin-bottom: 18px;
  }
}

ul {
  list-style: none;
}

.nav {
  display: flex;

  .nav-bar--active {
    box-sizing: border-box;
    border-bottom: 4px solid #30c2f3;
  }

  &-bar {
    position: relative;
    height: 100px;
    line-height: 100px;
    padding: 0 50px;
    cursor: pointer;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 100%;
      height: 3px;
      opacity: 0;
      background-color: #30c2f3;
      transform-origin: center;
      transform: translate(-50%, 0) scaleX(0);
      transition: all 0.3s ease-in-out;
    }

    &:hover::before {
      transform: translate(-50%, 0) scaleX(1);
      opacity: 1;
    }

    .sub-nav {
      @include sub-nav-style;
      position: absolute;
      z-index: 9999 !important;
      top: 100%;
      left: 0;

      a,
      a:link,
      a:visited,
      a:hover,
      a:active {
        text-decoration: none;
        color: inherit;
      }

      &-bar {
        position: relative;

        .third-nav {
          @include sub-nav-style;
          position: absolute;
          top: -16px;
          left: 100%;
        }
      }
    }
  }
}

.contact-us button {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
